import React, { FC, FormEvent, useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Dialog } from 'components/Dialog'
import { Icon } from 'components/Icon'
import { Heading } from 'components/Heading'
import { Button } from 'components/Button'
import { Text } from 'components/Text'
import { Stack } from 'components/Stack'
import styles from './IsochroneDialog.module.scss'
import { Slider } from 'components/Slider'
import { RadioGroup, RadioButton } from 'components/RadioButton'
import { AreaType } from 'models/project'
import { Flex } from 'components/Flex'
/*import { useUserContext } from 'context/user-context'*/

type IsochroneDialogProps = {
  onClose: () => void
  onConfirm: (data: any) => void
  status?: string
}

type Marks = {
  [key: string]: {
    [key: number]: {
      label: string
      value: number
    }
  }
}

export const IsochroneDialog: FC<IsochroneDialogProps> = ({
  onClose,
  onConfirm,
  status = 'idle',
}) => {
  const { t } = useTranslation()
  const [type, setType] = useState('')
  const [time, setTime] = useState<string>(AreaType.ISOCHRONE_WALK)
  const [measure, setMeasure] = useState(1)
  /*const [currentUser] = useUserContext()*/

  useEffect(() => setMeasure(1), [type])

  const marks: Marks = {
    time: {
      1: { label: '5 min', value: 5 },
      2: { label: '10 min', value: 10 },
      3: { label: '15 min', value: 15 },
      4: { label: '20 min', value: 20 },
      5: { label: '25 min', value: 25 },
      6: { label: '30 min', value: 30 },
    },
    radius: {
      1: { label: '250m', value: 250 },
      2: { label: '500m', value: 500 },
      3: { label: '750m', value: 750 },
      4: { label: '1km', value: 1000 },
      5: { label: '1.5km', value: 1500 },
      6: { label: '2km', value: 2000 },
    },
  }

  const [rval, setrval] = useState('')

  var radio = ''
  function valueRadio(event: any) {
    //const name = event.target.name;
    const re = /^[0-9\b]+$/
    if (event.target.value === '' || re.test(event.target.value)) {
      const value = event.target.value
      radio = value
      setrval(radio)
    }
  }

  const onFormSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    const isochrone = type === 'radius' ? AreaType.RADIUS : time
    if (type === 'radius' && rval !== '' && rval !== ' ') {
      onConfirm({ areaType: isochrone, [type]: rval })
    } else {
      onConfirm({ areaType: isochrone, [type]: marks[type][measure].value })
    }
  }

  return (
    <Dialog
      aria-label={t('create_project.isochrone_dialog.title')}
      isOpen={true}
      onClose={onClose}
      className={styles.isochroneDialog}
    >
      <Stack>
        <Stack space="xsmall" component="header">
          <Flex justify="start" align="center">
            <div className={styles.icon}>
              <Icon name="map-pin-line" />
            </div>
            <Heading size="secondary">{t('create_project.isochrone_dialog.title')}</Heading>
          </Flex>
          <Text>{t('create_project.isochrone_dialog.desc')}</Text>
        </Stack>

        <form onSubmit={onFormSubmit}>
          <Stack space="medium">
            <RadioGroup value={type} onChange={setType}>
              <RadioButton name="isochrone_type" value="time">
                {t('create_project.isochrone_dialog.time')}
              </RadioButton>
              <RadioButton name="isochrone_type" value="radius">
                {t('create_project.isochrone_dialog.radius')}
              </RadioButton>
            </RadioGroup>

            {type === 'time' ? (
              <>
                <RadioGroup value={time} onChange={setTime}>
                  <RadioButton name="walk" value={AreaType.ISOCHRONE_WALK}>
                    <Icon name="walk-line" className={styles.buttonIcon} />{' '}
                    {t('create_project.isochrone_dialog.walking')}
                  </RadioButton>
                  <RadioButton name="car" value={AreaType.ISOCHRONE_CAR}>
                    <Icon name="roadster-line" className={styles.buttonIcon} />{' '}
                    {t('create_project.isochrone_dialog.car')}
                  </RadioButton>
                  <RadioButton name="bike" value={AreaType.ISOCHRONE_BIKE}>
                    <Icon name="riding-line" className={styles.buttonIcon} />{' '}
                    {t('create_project.isochrone_dialog.biking')}
                  </RadioButton>
                  {/*{currentUser!.country.id === 1 && (
                    <RadioButton name="ptransport" value={AreaType.ISOCHRONE_PUBLICTRANSPORT}>
                      <Icon name="bus-2-line" className={styles.buttonIcon} />{' '}
                      {t('create_project.isochrone_dialog.ptransport')}
                    </RadioButton>
                  )}*/}
                </RadioGroup>
              </>
            ) : null}

            {!!type && (
              <Slider min={1} max={6} marks={marks[type]} onChange={setMeasure} value={measure} />
            )}

            {type === 'radius' ? (
              <>
                <div>
                  <label style={{ color: '#7f7f7f' }}>
                    {t('create_project.isochrone_dialog.alt')}
                  </label>
                  <br></br>
                  <br></br>
                  <input
                    id="txtRadio"
                    value={rval}
                    type="text"
                    className={styles.textInput}
                    onChange={valueRadio}
                  />{' '}
                  <label style={{ color: '#7f7f7f' }}>
                    {' '}
                    {t('create_project.isochrone_dialog.measure')}
                  </label>
                </div>
              </>
            ) : null}

            <Button disabled={!type} type="submit" full loading={status === 'loading'}>
              {t('create_project.isochrone_dialog.cta')}
            </Button>
          </Stack>
        </form>
      </Stack>
    </Dialog>
  )
}

IsochroneDialog.displayName = 'IsochroneDialog'
